/********************************************************************************
 * Copyright (C) 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

import * as common from '../../common/quick-pick-service';
/**
 * @deprecated import from `@theia/core/lib/common/quick-pick-service` instead
 */
export const QuickPickService = common.QuickPickService;
/**
 * @deprecated import from `@theia/core/lib/common/quick-pick-service` instead
 */
export type QuickPickService = common.QuickPickService;
/**
 * @deprecated import from `@theia/core/lib/common/quick-pick-service` instead
 */
export type QuickPickOptions = common.QuickPickOptions;
/**
 * @deprecated import from `@theia/core/lib/common/quick-pick-service` instead
 */
export type QuickPickItem<T> = common.QuickPickItem<T>;
/**
 * @deprecated import from `@theia/core/lib/common/quick-pick-service` instead
 */
export type QuickPickSeparator = common.QuickPickSeparator;
/**
 * @deprecated import from `@theia/core/lib/common/quick-pick-service` instead
 */
export type QuickPickValue<T> = common.QuickPickValue<T>;
